import {Injectable} from '@angular/core';
import {GraphKnDataService} from './graph-kn.data.service';
import {Text} from 'konva/lib/shapes/Text';
import {filter, Observable, Subscription, tap} from 'rxjs';
import {GraphKnTransformService} from './graph-kn.trasform.service';
import {GraphKnLayerSettingService} from './graph-kn.layers-setting.service';
import {GraphKnConnectorsLayersService} from './graph-kn.connectros-layers.service';
import {Rect} from 'konva/lib/shapes/Rect';
import {Group} from 'konva/lib/Group';
import {BUSINESS_PROCESS_LAYER_ID, CONTRACT_LAYER_ID} from '../models/graph-kn.cm-api-models';
import {IGraphData, IStorageSettings} from '../models/graph-kn.model-interfaces';
import {GraphKnRestrictionsService} from './graph-kn.restrictions.service';
import {COLOR_CONTRACT_LAYER, COLOR_SUBCONTRACT_LAYER} from '../models/graph-kn.cm.layers-model-const';
import {SETTING_STORAGE, TARGET_TYPES_WITH_RESTRICTIONS} from '../models/graph-kn.cm.model-const';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import { ContractDataService } from '../../contracts/services/contract-data.service';
import { ContractGetTargetDataService } from '../../contracts/services/contract-get-target-data.service';
import { BP_ACTIVE_STEP_COLOR } from '../styles/graph-colors';

@Injectable({
    providedIn: 'root'
})
export class GraphKnTSubscriptionService {

    constructor(
        private knDataService: GraphKnDataService,
        private knTransformService: GraphKnTransformService,
        private knLayerSettingService: GraphKnLayerSettingService,
        private knConnectorsService: GraphKnConnectorsLayersService,
        private knRestrictionsService: GraphKnRestrictionsService,
        private contractDataService: ContractDataService,
        private contractGetTargetDataService: ContractGetTargetDataService,
        private dbService: NgxIndexedDBService
    ) {
    }
    subUserPrivilegesSet() : Observable<boolean> {
        return this.contractDataService.subUserPrivilegesSet.asObservable().pipe(filter(done=>done===true))
    }
    subContractNameRefresh(): Subscription {
        return this.contractDataService.subStepDataChanged.asObservable().subscribe(stepDataUpdated => {
            this.knDataService.contractGD.forEach((graphData, layerID) => {
                let layer = this.knDataService.layersMap.get(layerID)?.layer;
                let label = layer?.findOne('#' + stepDataUpdated.step.guid + 'text') as Text;
                let labelLoad = layer?.findOne('#' + stepDataUpdated.step.guid + 'load') as Text;
                if (label && stepDataUpdated.stepName !== label.text()) {
                    label.text(stepDataUpdated.stepName)
                }
                if (labelLoad) {
                    labelLoad.text('');
                    let ind: number = this.knDataService.loadingIds.indexOf(labelLoad.attrs.id.replace('load', ''))
                    ind >= 0 ? this.knDataService.loadingIds.splice(ind, 1) : null;
                    if (TARGET_TYPES_WITH_RESTRICTIONS.includes(stepDataUpdated.step.target_type || 'none')) {
                        let changedStepI = graphData.nodes.findIndex(nd => nd.id === stepDataUpdated.step.guid);
                        changedStepI ? graphData.nodes[changedStepI].contract_step_data = stepDataUpdated.step : null;
                        this.knRestrictionsService.prepareRestrictions(graphData)
                    }
                }
            })
        })
    }

    subReceivedBPData(): Subscription {
        return this.knDataService.generateGraphDataBP$.asObservable()
            .pipe(filter(data => (data as IGraphData).hasOwnProperty('nodes')))
            .subscribe(data => {
                this.knDataService.businessProcessGD = this.knTransformService.transformIncomingBP(data as IGraphData);
                let layerData = this.knLayerSettingService.setBusinessProcessLayer();
                this.knDataService.businessProcessGD?.nodes ? this.knLayerSettingService.removeBPLayer() : null
                layerData && this.knDataService.businessProcessGD?.nodes.length ? this.knLayerSettingService.prepareBPLayer(layerData) : null;
            })
    }
    subGraphSettingsChanged(): Subscription {
			return this.knDataService.subGraphSettingsChangesd$.asObservable()
				.subscribe(data => {
					this.knDataService.layoutDagreSettings.set(...data) 
					let layerData = this.knDataService.layersMap.get(data[0])
					this.knDataService.layoutDagre.settings = data[1]
					this.knLayerSettingService.removeBPLayer();
					layerData?	this.knLayerSettingService.prepareBPLayer(layerData) : null;
				})
    }

    subTaskData(): Subscription {
        return this.knDataService.generateTaskGraphData$.asObservable().pipe(
        ).subscribe(data => {
            this.knDataService.activeStepId = data.activeStepId
            this.knDataService.selectedNodeGroupId
            this.knDataService.businessProcessGD = this.knTransformService.transformIncomingTask(data);
            let layerData = this.knLayerSettingService.setBusinessProcessLayer();
            this.knDataService.businessProcessGD?.nodes ? this.knLayerSettingService.removeBPLayer() : null
            layerData && this.knDataService.businessProcessGD?.nodes.length ? this.knLayerSettingService.prepareBPLayer(layerData) : null;
            let layerBP = this.knDataService.layersMap.get(BUSINESS_PROCESS_LAYER_ID)?.layer;
            let activeRect = (layerBP?.findOne('#' + this.knDataService.activeStepId) as Group)?.children.filter(el => el instanceof Rect)[0]
            activeRect?.stroke(BP_ACTIVE_STEP_COLOR)
        })
    }

    subReceivedSubContractData(): Subscription {
        return this.knDataService.generateGraphDataSubContract$.asObservable()
            .subscribe(data => {
                data.nodes.forEach(nd => nd.nodeType === 'subContractStep')
                data.state = 'closed'
                this.knDataService.nodeHeight = 0;
                this.knDataService.nodeWidth = 0;
                this.knDataService.topNodeYpos = 0;
                let selectedLayerId = (this.knDataService.selectedNodeGroup?.parent?.children.find(el => el instanceof Rect) as Rect).attrs.id
                let subContractLayerID = 'sub_' + data.parent_contract_guid;
                let contractNodes = this.knDataService.contractNodes.get(selectedLayerId)
                let subContractGP = this.knTransformService.transformIncomingSubContract(data, contractNodes)

                let setNewLayer = !this.knDataService.contractGD.has(subContractLayerID)
                if (subContractGP) {
                    this.knDataService.contractGD.set(subContractLayerID, subContractGP);
                    subContractGP.nodes.forEach(node => {
                        let step = node.contract_step_data;
                        if (step && step.target_key) {
                            this.contractGetTargetDataService.getTaskTargetData(step)
                            this.knDataService.loadingIds.push(node.id || '')
                        }
                    });
                    this.knLayerSettingService.setContractLayer(subContractLayerID, setNewLayer, COLOR_SUBCONTRACT_LAYER, true);
                }
                this.knConnectorsService.connectContractLayers(selectedLayerId, subContractLayerID, 'subContract')
            })
    }

/*     subGetUsers(): Subscription {
        return this.authService.getAllUsersWithPagination({limit: 50, current_page: 1})
            .pipe(map(data => {
                return {code: 200, response: {users: data.data}}
            }))
            .subscribe(users => {
               // this.knDataService.users = users?.response?.users as unknown as IUser[];
                //this.knUIElementsService.updateUserGroup();
            });
    } */

    subNewStepsAdded(): Subscription {
        return this.knDataService.generateGraphDataContract$.asObservable().pipe(filter(data => data.redraw)).subscribe(graphData => {
            this.knDataService.contractGD.set(CONTRACT_LAYER_ID, graphData)
            let contractGD = this.knDataService.contractGD.get(CONTRACT_LAYER_ID)
            this.knDataService.nodeWidth = 0;
            this.knDataService.nodeHeight = 0;
            if (contractGD?.nodes?.length) {
                this.knTransformService.transformIncomingContract(contractGD,graphData.data?.guid||'');
                this.knLayerSettingService.setContractLayer(CONTRACT_LAYER_ID, false);
                this.knDataService.lastContractStepId = contractGD.nodes[contractGD.nodes?.length - 1]?.id.replace(/image|number/g, '');
            }
        })
    }

    subContractSettingsChanged(): Subscription {
        return this.contractDataService.contractGraphTypeSub.asObservable().subscribe(settings => {
            let data: IStorageSettings = {
                setting_id: 'contract_graph_type',
                setting_value: settings
            }
            this.dbService.update(SETTING_STORAGE, data).subscribe()
            let settingsContractGraph = this.knDataService.layoutDagreSettings.get('contractLayer')
            settingsContractGraph ? settingsContractGraph.layoutModel = settings : null;
            this.knDataService.graphStage.removeChildren()
            let contactData = structuredClone(this.knDataService.contractGD.get(CONTRACT_LAYER_ID))
            this.knDataService.resetValues(false)
            contactData ? this.knDataService.contractGD.set(CONTRACT_LAYER_ID, contactData) : null
            this.knLayerSettingService.setContractLayer(CONTRACT_LAYER_ID, true, COLOR_CONTRACT_LAYER);
        })
    }
}